import { render, staticRenderFns } from "./CognitiveZLSJ.vue?vue&type=template&id=ac17312a&scoped=true"
import script from "./CognitiveZLSJ.vue?vue&type=script&lang=js"
export * from "./CognitiveZLSJ.vue?vue&type=script&lang=js"
import style0 from "./CognitiveZLSJ.vue?vue&type=style&index=0&id=ac17312a&prod&scoped=true&lang=css"
import style1 from "./CognitiveZLSJ.vue?vue&type=style&index=1&id=ac17312a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac17312a",
  null
  
)

export default component.exports